export const iconFontAwesomeScienceFrog = (
	<i className="fa-solid fa-frog"></i>
);
